import { render, staticRenderFns } from "./matchagreement.vue?vue&type=template&id=6f5a0122&scoped=true"
import script from "./matchagreement.vue?vue&type=script&lang=js"
export * from "./matchagreement.vue?vue&type=script&lang=js"
import style0 from "./matchagreement.vue?vue&type=style&index=0&id=6f5a0122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a0122",
  null
  
)

export default component.exports